import React, {useEffect, useState, createContext} from "react";
import instance from "../lib/api/instance";
import * as trainingMock from "../lib/api/trainingMock";

type UserMode = {
    type: "user";
    firstName?: string;
    lastName?: string;
};

type ManagerMode = {
    managerId: string;
    type: "manager";
    firstName: string;
    lastName: string;
};

type CashierMode = UserMode | ManagerMode;

type StationContext = {
    cashierMode: CashierMode;
    setCashierMode: (mode: CashierMode) => void;
    isTraining: boolean;
    toggleIsTraining: (turnOn: boolean) => void;
    isCCPaymentDisabled: boolean;
    setIsCCPaymentDisabled: (val: boolean) => void;
    errorAfterPaymentsProcessed: boolean;
    setErrorAfterPaymentsProcessed: (val: boolean) => void;
    resetCurrentOrderStateOnCartEmptied: boolean;
    setResetCurrentOrderStateOnCartEmptied: (val: boolean) => void;
    isSubmittingOrder: boolean;
    setIsSubmittingOrder: (val: boolean) => void;
};

export const StationContext = createContext<StationContext>({
    cashierMode: {
        type: "user",
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setCashierMode: () => {},
    isTraining: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    toggleIsTraining: () => {},
    isCCPaymentDisabled: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setIsCCPaymentDisabled: () => {},
    errorAfterPaymentsProcessed: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setErrorAfterPaymentsProcessed: () => {},
    resetCurrentOrderStateOnCartEmptied: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setResetCurrentOrderStateOnCartEmptied: () => {},
    isSubmittingOrder: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setIsSubmittingOrder: () => {},
});

export function StationContextProvider(props: {children: React.ReactNode}) {
    const [isTraining, setIsTraining] = useState(false);
    const [cashierMode, setCashierMode] = useState<CashierMode>({
        type: "user",
    });
    const [isCCPaymentDisabled, setIsCCPaymentDisabled] = useState(false);
    const [errorAfterPaymentsProcessed, setErrorAfterPaymentsProcessed] =
        useState(false);
    const [
        resetCurrentOrderStateOnCartEmptied,
        setResetCurrentOrderStateOnCartEmptied,
    ] = useState(false);
    const [isSubmittingOrder, setIsSubmittingOrder] = useState(false);

    useEffect(() => {
        if (!isTraining) {
            trainingMock.removeMock();
        } else {
            trainingMock.setMockResponses(instance);
        }
    }, [isTraining]);

    function toggleIsTraining(turnOn: boolean) {
        setIsTraining(turnOn);
        setCashierMode({
            type: "user",
        });
    }

    return (
        <StationContext.Provider
            value={{
                cashierMode,
                setCashierMode,
                isTraining,
                toggleIsTraining,
                isCCPaymentDisabled,
                setIsCCPaymentDisabled,
                errorAfterPaymentsProcessed,
                setErrorAfterPaymentsProcessed,
                resetCurrentOrderStateOnCartEmptied,
                setResetCurrentOrderStateOnCartEmptied,
                isSubmittingOrder,
                setIsSubmittingOrder,
            }}>
            {props.children}
        </StationContext.Provider>
    );
}
